/* eslint-disable */
import { Dates, LocalDate, } from './util/dates';
import { Observable, Observer } from 'rxjs';
import { environment } from '../../environments/environment';
import { Order, OrderType, Services, } from './util/services';
import { MemStorage } from './util/mem-storage';
import { Injectable } from '@angular/core';
import { TypeItem, UiConstants } from '../util/core-utils';
import { SurveyRecord } from './survey/survey-record.service';
import { DisabledItem } from '../util/search-utils';
import { RuntimeConfiguration } from './runtime-configuration';
import { LoggedInUserStorage } from './util/storages';
/* eslint-enable */

@Injectable()
export class SurveyRecordSearchService {

  constructor() { }

  getSearchData(request: SurveyRecordSearch.SearchDataGetRequest): Observable<SurveyRecordSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<SurveyRecordSearch.SearchDataResult>) => {
      try {
        observer.next(storage.read(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  setSearchData(request: SurveyRecordSearch.SearchDataSetRequest): Observable<SurveyRecordSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<SurveyRecordSearch.SearchDataResult>) => {
      try {
        observer.next(storage.save(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  resetSearchData(request: SurveyRecordSearch.SearchDataGetRequest): Observable<SurveyRecordSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<SurveyRecordSearch.SearchDataResult>) => {
      try {
        observer.next(storage.reset(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  private createStorage(): SurveyRecordSearch.Storage {
    return new SurveyRecordSearch.Storage();
  }

}

export namespace SurveyRecordSearch {

  export interface SearchDataGetRequest {
  }

  export interface SearchDataSetRequest {
    searchData: SearchData;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<SurveyRecord.OrderField>;
    name: string;
    ownerUser: TypeItem | undefined;
    updateTimeFrom: LocalDate;
    updateTimeTo: LocalDate;
    disabled?: DisabledItem;
  }

  interface StoredSearchRawDataBase {
    version: number;
  }

  interface StoredSearchRawData extends StoredSearchRawDataBase {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<SurveyRecord.OrderField>;
    name: string;
    ownerUser: TypeItem | undefined;
    updateTimeFrom?: string;
    updateTimeTo?: string;
    disabled?: DisabledItem;
  }

  export class Storage {

    /**
     * Increment this version if you change the SearchData interface.
     */
    private static readonly VERSION: number = 4;

    private static readonly DEFAULT_SEARCH_DATA: SearchData = {
      itemsPerPage: UiConstants.pageNumbers[0],
      pageNumber: 1,
      order: {
        field: SurveyRecord.OrderField.ID,
        type: OrderType.DESC
      },
      name: '',
      ownerUser: undefined,
      updateTimeFrom: Dates.emptyLocalDate(),
      updateTimeTo: Dates.emptyLocalDate(),
      disabled: DisabledItem.active()
    };

    constructor() { }

    public read(request: SearchDataGetRequest): SearchDataResult {
      let rawBase: StoredSearchRawDataBase;
      try {
        const key = this.generateKey();
        const json = MemStorage.getItem(key);
        if (!json) {
          return this.createDefaultResult();
        }
        rawBase = JSON.parse(json);
      }
      catch (error) {
        return this.createDefaultResult();
      }
      if (Storage.VERSION === rawBase.version) {
        const raw: StoredSearchRawData = <StoredSearchRawData> rawBase;
        return this.fromRaw(raw);
      }
      return this.createDefaultResult();
    }

    public reset(request: SearchDataGetRequest): SearchDataResult {
      return this.save({
        searchData: Storage.DEFAULT_SEARCH_DATA,
      });
    }

    public save(request: SearchDataSetRequest): SearchDataResult {
      const key = this.generateKey();
      const raw = this.toRaw(request.searchData);
      const json = JSON.stringify(raw);
      MemStorage.setItem(key, json);
      return this.read(request);
    }

    private generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Survey-Record';
    }

    private createDefaultResult(): SearchDataResult {
      return {
        searchData: Storage.DEFAULT_SEARCH_DATA,
      };
    }

    private fromRaw(data: StoredSearchRawData): SearchDataResult {
      return {
        searchData: {
          itemsPerPage: data.itemsPerPage,
          pageNumber: data.pageNumber,
          order: data.order,
          name: data.name,
          ownerUser: data.ownerUser,
          updateTimeFrom: Services.toLocalDate(data.updateTimeFrom),
          updateTimeTo: Services.toLocalDate(data.updateTimeTo),
          disabled: data.disabled
        }
      };
    }

    private toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: Storage.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        name: data.name,
        ownerUser: data.ownerUser,
        updateTimeFrom: Services.localDateToString(data.updateTimeFrom),
        updateTimeTo: Services.localDateToString(data.updateTimeTo),
        disabled: data.disabled
      };
    }

  }

}
